// Owner: record-runtime. The `record-peek` layer (plan §4.1, §7.3): a right side sheet with the record's
// interface (features/records/components/RecordPeek.tsx, loaded on first open). Open it with
// `openLayer('record-peek', { objectKey, recordId, list? })` from any screen.
import { lazy } from 'react';
import { defineGlobalLayer, openLayer } from '../shell/overlays';

// Development builds expose `openLayer` for end-to-end checks of layers no screen opens yet.
if (import.meta.env.DEV && typeof window !== 'undefined')
  (window as unknown as { __drOpenLayer?: typeof openLayer }).__drOpenLayer = openLayer;

export default defineGlobalLayer({
  id: 'record-peek',
  component: lazy(() =>
    import('../features/records/components/RecordPeek').then((m) => ({ default: m.RecordPeekLayer })),
  ),
});
